import { render, staticRenderFns } from "./Liveshopping.vue?vue&type=template&id=1512f820&scoped=true&"
import script from "./Liveshopping.vue?vue&type=script&lang=js&"
export * from "./Liveshopping.vue?vue&type=script&lang=js&"
import style0 from "./Liveshopping.vue?vue&type=style&index=0&id=1512f820&prod&lang=scss&"
import style1 from "./Liveshopping.vue?vue&type=style&index=1&id=1512f820&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1512f820",
  null
  
)

export default component.exports